<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">    
      <el-form :inline="true" class="demo-form-inline backborder1" size="small">
      	  <el-form-item style="width:100%">
      	  	  <el-tag type="danger">温馨提示：用户只能选择已经分配权限的分类，建议添加组别后立即设置分配权限</el-tag>
      	  </el-form-item>
          <el-form-item v-if="actionauth.config_manager_cate_add=='true'">
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="createClassDialog = true">新增用户分类</el-button>
          </el-form-item>
      </el-form>
      <div class="backborder2" style="margin-top:10px">
          <el-table :data="classlists">
              <el-table-column label="用户分类名称">
              	  <template slot-scope="scope">
              	  	  <span v-if="scope.row.id==1" style="color:green">{{scope.row.groupname}}</span>
              	  	  <span v-if="scope.row.id!=1">{{scope.row.groupname}}</span>
	              </template>
              </el-table-column>
              <el-table-column label="是否设置权限" prop="isroll" align="center">
              	  <template slot-scope="scope">
              	  	  <el-tag v-if="scope.row.isroll=='是'" type="success">{{scope.row.isroll}}</el-tag>
              	  	  <el-tag v-if="scope.row.isroll=='否'" type="danger">{{scope.row.isroll}}</el-tag>
	              </template>
              </el-table-column>
              <el-table-column
	              label="操作"
	              width="200" align="center" v-if="actionauth.config_manager_cate_edit=='true' || actionauth.config_manager_cate_del=='true' || actionauth.config_manager_authority=='true'">
	              <template slot-scope="scope">
	              	  <el-button type="primary" size="small" circle icon="el-icon-setting"  @click="editauthority(scope.row)" v-if="scope.row.id!=1 && actionauth.config_manager_authority=='true'"></el-button>
	                  <el-button type="primary" size="small" circle icon="el-icon-edit"  @click="editClassDialog(scope.row)" v-if="scope.row.id!=1 && actionauth.config_manager_cate_edit=='true'"></el-button>
	                  <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delClass(scope.row)" v-if="scope.row.id!=1 && actionauth.config_manager_cate_del=='true'"></el-button>
	              </template>
              </el-table-column>
          </el-table>
      </div>
      
      <!------------------------add class---------------------->
      <el-dialog title="新增用户分类" :visible.sync="createClassDialog" width="30%">
          <el-form ref="createclass" :model="createclass" :rules="classrules" label-width="100px" size="small">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="createclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="createClassDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="createClassLoading" @click="createClassSave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------add class end---------------------->
      
      <el-dialog title="修改分类权限" :visible.sync="updateauthorityDialog" width="60%" top="5vh">
	      <el-tree ref="tree" v-loading="treeLoading" :data="authority" highlight-current show-checkbox node-key="id"></el-tree>
      	  <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateauthorityDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateauthorityLoading" @click="updateauthoritySave">保 存</el-button>
          </div>
      </el-dialog>
      
      <!------------------------edit class---------------------->
      <el-dialog title="编辑分类" :visible.sync="updateClassDialog" width="30%">
          <el-form ref="updateclass" :model="updateclass" :rules="classrules" label-width="100px" size="small">
            <el-col :span="22">
              <el-form-item label="分类名称" prop="groupname">
                <el-input v-model="updateclass.groupname"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="updateClassDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updateClassLoading" @click="updateClassSave">保 存</el-button>
          </div>
      </el-dialog>
      
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Manager/index",
      classDialog:false,
      classListLoading:false,
      classlists:[],   
      createClassDialog:false,
      classrules: {
        groupname: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
        ]
      },
      createClassLoading:false,
      createclass: {
        act:'addclass',
        token:this.$cookies.get('token'),
        groupname:'',
      },
      updateauthorityDialog:false,
      treeLoading: false,
      authoritygroupid:[],
      authoritygroupname:[],
      authority:[],
      updateauthorityLoading: false,
      updateClassDialog:false,
      updateclass: {
        act:'editclass',
        token:this.$cookies.get('token'),
        id:'',
        groupname:'',
      },
      updateClassLoading:false,
         
    }
  },
  mounted(){
    this.getactionauth();
    this.getClassList(); //获取管理员分类信息列表
  },
  methods:{
   
    /** 获取操作权限 **/
	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  	
    //分类列表
    getClassList(){
      this.classListLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act:'getClass',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.classListLoading = false;
        }else{
          this.classlists = JSON.parse(Base64.decode(res.data.Data));
          this.classListLoading = false;
        }
      }).catch((res) => {
          this.classListLoading=false;
      });
    },
    
    //新增分类
    createClassSave(){
      // 主动校验
      this.$refs.createclass.validate((valid) => {
          if (valid) {
              this.createClassLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.createclass).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.createClassLoading=false;
                  }else{
                    this.$message.success('新增分类：'+this.createclass.groupname+'成功，请立刻给该分类分配权限');
                    this.createClassDialog=false;
                    this.createClassLoading=false;
                    this.resetClass();
                    this.getClassList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createClassDialog=false;
                  this.createClassLoading=false;
              });
          }else {
            return false;
          }
      });
    },
    
    resetClass() {
        this.$refs.createclass.resetFields();
    },
    
    //获取用户权限
    editauthority(obj) {
    	this.updateauthorityDialog=true;
    	this.treeLoading=true;
    	this.authoritygroupid=obj.id;
    	this.authoritygroupname=obj.groupname;
    	var resource = this.$resource(this.GLOBAL.domain+"Authority/index");
    	resource.query({ act:'myauthority',groupid:obj.id,type:'change',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.treeLoading=false;
	        }else{
	            var mymenu = JSON.parse(Base64.decode(res.data.Data));
	            this.authority=mymenu.menus;
			    //勾选当前用户具有的权限
			    if(mymenu.ids!='') {
			  	    this.$refs.tree.setCheckedKeys(mymenu.ids);
			    }else {
			  	    this.$refs.tree.setCheckedKeys([]);
			    }
			    this.treeLoading=false;
	        }
        }).catch((res) => {
            this.treeLoading=false;
        });
    },
    
    
    //保存修改后的权限
    updateauthoritySave() {
    	this.updateauthorityLoading=true;
    	var ids=this.$refs.tree.getCheckedKeys();
    	if(ids=='') {
    	    this.$message.error('请选择相关权限');
    	    this.updateauthorityLoading=false;
    	    return false;
    	}
    	
    	var resource = this.$resource(this.GLOBAL.domain+"Authority/index");
    	resource.query({ act:'savemyauthority',groupid:this.authoritygroupid,ids:ids,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.updateauthorityLoading=false;
	            this.updateauthorityDialog=false;
	        }else{
	            this.$message.success('设置分类：'+this.authoritygroupname+'权限成功');
			    this.updateauthorityLoading=false;
			    this.updateauthorityDialog=false;
			    this.getClassList();
	        }
        }).catch((res) => {
            this.updateauthorityLoading=false;
            this.updateauthorityDialog=false;
        });
    	
    },
    
    //删除
    delClass(item){
      this.$confirm('此操作将永久删除 ' + item.groupname + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'delclass',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.groupname + '!');
                    this.getClassList();
                  }
              }).catch((res) => {
                      
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
    //显示编辑分类框
    editClassDialog(item){
      this.updateClassDialog=true;
      this.updateclass.id=item.id;
      this.updateclass.groupname=item.groupname;
    },
    
    //编辑分类的保存
    updateClassSave(){
      // 主动校验
      this.$refs.updateclass.validate((valid) => {
          if (valid) {
              this.updateClassLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.updateclass).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.updateClassLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateClassDialog=false;
                    this.updateClassLoading=false;
                    this.getClassList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createClassDialog=false;
                  this.createClassLoading=false;
              });
          }else {
            return false;
          }
      });
    },
    
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/config/Managercate.vue